import { render, staticRenderFns } from "./login-malaysia.vue?vue&type=template&id=e6b18fd6&scoped=true&"
import script from "./login-malaysia.vue?vue&type=script&lang=ts&"
export * from "./login-malaysia.vue?vue&type=script&lang=ts&"
import style0 from "./login-malaysia.vue?vue&type=style&index=0&id=e6b18fd6&prod&lang=scss&scoped=true&"
import style1 from "./login-malaysia.vue?vue&type=style&index=1&id=e6b18fd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b18fd6",
  null
  
)

export default component.exports